import React from "react";
import { LuUndo2 } from "react-icons/lu";

const ReviewBar: React.FC<{
  count: number;
  onKeep: () => void;
  onUndo: () => void;
}> = ({ count, onKeep, onUndo }) => {
  const label =
    count > 0
      ? `Sandbox AI made ${count} change${count === 1 ? "" : "s"}`
      : "Sandbox AI updated your dashboard";

  return (
    <div className="sandbox-ai-review-bar">
      <span className="sandbox-ai-review-text">{label}</span>
      <div className="sandbox-ai-review-actions">
        <button type="button" className="sandbox-ai-review-undo" onClick={onUndo}>
          <LuUndo2 /> Undo
        </button>
        <button type="button" className="sandbox-ai-review-keep" onClick={onKeep}>
          Keep
        </button>
      </div>
    </div>
  );
};

export default ReviewBar;
